export interface User {
  id: number;
  username: string;
  /** Relation-derived friendly name (contact full name) from UserResource. */
  display_name?: string | null;
  contact_id: number | null;
  client_id: number | null;
  /** Relation-derived client name from UserResource. */
  client_name?: string | null;
  user_type_id: number;
  security_role_id: number;
  active: boolean;
  last_login: string | null;
  roles?: string[];
  permissions?: string[];
  /** Canonical dashboard role from the API (derived server-side from user_type_id). */
  dashboard_role?: string;
}

/** `dashboard_role` values the Vendor Portal admits (SLS-1174; the API gate in VendorPortalRequest). */
export const VENDOR_PORTAL_ROLES: readonly string[] = ['vendor', 'customer-service', 'system-admin'];

export interface LoginRequest {
  username: string;
  password: string;
  device_name?: string;
}

export interface LoginResponse {
  user: User;
  token: string;
  token_type: 'Bearer';
}
